import { FaroButton } from "@faro-lotv/flat-ui";
import { Stack } from "@mui/material";
import type { JSX } from "react";

export type AnnotationEditorButtonsProps = {
  /**
   * Text to show in the confirm button
   *
   * @default Edit
   */
  confirmButtonText?: string;

  /** Function called when the cancel button is clicked */
  onCancelButtonClick?(): void;

  /** Function called when the confirm button is clicked */
  onConfirmButtonClick?(): void;

  /** If `true`, the cancel and confirm buttons will be disabled */
  disabled?: boolean;

  /** If `true`, it shows a spinner inside the confirm button */
  showConfirmButtonSpinner?: boolean;

  /** If `true`, the confirm button will be disabled */
  disabledConfirmButton?: boolean;
};

/**
 * @returns The buttons to use to confirm or cancel annotation creation or edition
 */
export function AnnotationEditorButtons({
  confirmButtonText = "Save",
  onCancelButtonClick,
  onConfirmButtonClick,
  disabled,
  showConfirmButtonSpinner,
  disabledConfirmButton,
}: AnnotationEditorButtonsProps): JSX.Element {
  return (
    <Stack direction="row" sx={{ justifyContent: "end" }}>
      <FaroButton
        variant="ghost"
        dark
        onClick={onCancelButtonClick}
        disabled={disabled}
      >
        Cancel
      </FaroButton>

      <FaroButton
        dark
        onClick={onConfirmButtonClick}
        isLoading={showConfirmButtonSpinner}
        disabled={!!disabled || disabledConfirmButton}
      >
        {confirmButtonText}
      </FaroButton>
    </Stack>
  );
}
